import React from "react";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="tc-footer-style2">
      <div className="container">
        <div className="foot-main-content">
          <div className="row">
            <div className="col-lg-4">
              <div className="foot-info">
                <h3 className="fsz-35 fw-500">
                  {t("footer.tagline.nature")} {t("footer.tagline.sea")}{" "}
                  {t("footer.tagline.tranquility")}{" "}
                 
                    {t("footer.tagline.harmony")}
               
                </h3>
              </div>
            </div>
            <div className="col-lg-3 offset-lg-1">
              <div className="links-group">
                <h5 className="sub-title fsz-24 fw-500 mb-30 mt-5 mt-lg-0">
                  {t("footer.location.title")}
                </h5>
                <ul>
                  <li>
                    <a href="https://maps.app.goo.gl/FDktBUJzSPJKZewr7">
                      {" "}
                      {t("footer.location.address")}{" "}
                    </a>
                  </li>
                  <li>
                    <a href="#"> {t("footer.location.email")} </a>
                  </li>
                  <li>
                    <a href="tel:+359893366406"> +359 893366406 </a>
                  </li>
                  <li>
                    <a
                      href="/innerpages/contact"
                      className="butn borderd border rounded-pill mt-10 hover-bg-black wow fadeInUp"
                      data-wow-delay="0.7s"
                    >
                      <span>
                        {t("footer.location.inquiry")}
                        <i className="small ms-1 ti-arrow-top-right"></i>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="links-group">
                <h5 className="sub-title fsz-24 fw-500 mb-30 mt-5 mt-lg-0">
                  {t("footer.navigation.aboutTitle")}
                </h5>
                <ul>
                  <li>
                    <a href="/innerpages/portfolio">
                      {" "}
                      {t("footer.navigation.apartments")}{" "}
                    </a>
                  </li>
                  <li>
                    <a href="/innerpages/gallery">
                      {" "}
                      {t("footer.navigation.gallery")}{" "}
                    </a>
                  </li>
                  <li>
                    <a href="/innerpages/projects">
                      {" "}
                      {t("footer.navigation.project")}{" "}
                    </a>
                  </li>
                  <li>
                    <a href="/home7_landscape">
                      {" "}
                      {t("footer.navigation.about")}{" "}
                    </a>
                  </li>
                  <li>
                    <a href="/innerpages/contact">
                      {" "}
                      {t("footer.navigation.contact")}{" "}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="links-group">
                <h5 className="sub-title fsz-24 fw-500 mb-30 mt-5 mt-lg-0">
                  {t("footer.help.title")}
                </h5>
                <ul>
                  <li>
                    <a href="/innerpages/terms"> {t("footer.help.terms")} </a>
                  </li>
                  <li>
                    <a href="/innerpages/terms"> {t("footer.help.privacy")} </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="foot">
          <div className="row align-items-center">
            <div className="col-lg-2">
              <a href="#" className="logo">
                <img src="/home1/assets/img/logo2.png" alt="" />
              </a>
            </div>
            <div className="col-lg-3">
              <p className="copy">{t("footer.copyright")}</p>
            </div>
            <div className="col-lg-5">
              <div className="social-links">
                <a href="https://www.facebook.com/profile.php?id=61578008546140&mibextid=wwXIfr">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://www.instagram.com/botanicheska302?igsh=MXd6ZDA1aXBlMTdoZg%3D%3D&utm_source=qr">
                  <i className="fab fa-instagram"></i>
                </a>
                   <a href="https://share.google/WPZzX9FL3kLehI5UF">
                  <i className="fab fa-google"></i>
                </a>

                
              </div>
            </div>
            <div className="col-lg-2">
              <a
                href="#"
                className="butn borderd border rounded-pill hover-bg-black"
                id="to_top"
              >
                <span>
                  {t("footer.backToTop")}{" "}
                  <i className="ms-2 fal fa-chevron-up"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <img src="/home2/assets/img/foot_shap.svg" alt="" className="shap" />
    </footer>
  );
}

export default Footer;
